"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'recording.process.failed': 'Failed to process recording',
};
